var _defs, _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 678 546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0e477a;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.4,
    y: 61.7,
    width: 553.2,
    height: 312.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.7,362.9S80.5,142,75,137.5c-13.3-10.4-16.9-31.3-6.7-43.9,19.3-23.8,43-6.7,54.9,3.7,9.7,8.5,225,180,225,180V107.8c0-10.4-3-46.1,37.1-46.1h135.9c53.2,0,96.5,40.9,94.3,98.2v183c-.6,17.6-14.9,30.5-31.9,31.2-18.2-.6-30.5-18.2-30.5-31.2v-185.2c0-18.8-10.9-34.2-40.8-34.2h-102.5v216.4c0,9.3-2.6,21-10.9,27.7-20.2,17.7-44.2-4.6-44.2-4.6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.6,483.4l18.7-84.5h29.6c13.2,0,22.2,9.9,22.2,21.2s-9,28.2-31.4,28.2h-24.2l-7.8,35h-7.2ZM418.5,441.8c15.2,0,22.8-9.9,22.8-21.2s-6.6-15.2-15.6-15.2h-22.8l-8,36.2h23.6v.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.1,483.4l-16-35h-19.1l-7.8,35h-7.2l18.7-84.5h29c11.5,0,23,7.8,23,21.2s-11.5,27.5-28.8,28l16.6,35.2h-8.4ZM491,441.8c14.8,0,22.8-9.9,22.8-21.2s-7.8-15.2-16-15.2h-22.4l-8,36.4h23.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578.1,397.6c20.9,0,38,13,38,36.6s-21,50.8-46.8,50.8-38-13-38-36.6c-.2-28.6,20.8-50.8,46.8-50.8ZM577.5,404c-20.7,0-38.4,18.3-38.4,44s13.8,30.4,30.6,30.4,38.6-18.3,38.6-44c-.2-19.9-14-30.4-30.8-30.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLogo);
export default __webpack_public_path__ + "static/media/ProLogo.cda452c049248097f0df339eb60b7878.svg";
export { ForwardRef as ReactComponent };